import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { setFormVisible } from 'bookingform';

class Error extends React.Component {
  componentDidMount() {
    const { state } = this.props.location;
    if (state && state.showForm) {
      this.props.dispatch(setFormVisible(true));
    }
  }

  render() {
    return (
      <div className="Error">
        <i className="fa fa-gears"/>
        <h1>{this.context.t('We are currently performing maintenance tasks. Please, try again in a few minutes...')}</h1>
        <small>Code: {this.props.error}</small>
      </div>
    );
  }
}

Error.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default connect((state) => ({
  error: state.booking.availError,
}))(Error);
